import React from "react";
import style from "./CorruptedFileMessage.module.css";

/**
 * Shared error/status text shown in document viewers when a file
 * cannot be opened (missing, empty, or magic-byte check failed).
 * Also used while the integrity check is still running.
 */
const CorruptedFileMessage = ({ message }) => (
  <div className={style.errorBox}>{message}</div>
);

export default CorruptedFileMessage;
